import React, { useState } from "react";
import { Mail, ShieldCheck, ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import logoCapta from "../assets/logo-capta.png";

export default function ForgotSenha() {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [carregando, setCarregando] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setCarregando(true);

    try {
      const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;

      const res = await fetch(`${API_BASE_URL}/auth/forgot`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });

      // Backend responde OK genérico SEMPRE (por segurança). Mesmo se res.ok=false, tratamos sem vazar info.
      if (!res.ok) {
        // tenta ler msg, mas não depende disso
        try {
          const data = await res.json();
          console.warn("forgot response:", data);
        } catch (_) {}
      }

      toast.success(
        "✅ Se este e-mail estiver cadastrado, você receberá um link para redefinir a senha.",
      );

      // Opcional: voltar pro login após alguns segundos
      setTimeout(() => navigate("/login"), 800);
    } catch (err) {
      console.error(err);
      // Mesmo no erro, pode manter genérico (não vaza se existe ou não)
      toast.success(
        "✅ Se este e-mail estiver cadastrado, você receberá um link para redefinir a senha.",
      );
      setTimeout(() => navigate("/login"), 800);
    } finally {
      setCarregando(false);
    }
  };

  return (
    <div className="h-screen bg-gradient-to-br from-blue-900 to-blue-600 flex items-center justify-center py-6 px-4">
      <div className="bg-white rounded-3xl shadow-2xl px-6 pt-0 pb-6 max-w-md w-full">
        <div className="flex justify-center mb-0">
          <img
            src={logoCapta}
            alt="Logo CaptaCRM"
            className="w-40 drop-shadow-2xl transition-transform duration-700 ease-out animate-fade-in"
            style={{ animationDelay: "0.2s" }}
          />
        </div>

        <div className="text-center mt-0">
          <h1 className="text-2xl font-extrabold text-blue-900 flex items-center justify-center gap-2">
            <ShieldCheck className="w-6 h-6 text-blue-700" />
            Esqueci minha senha
          </h1>
          <p className="text-sm text-gray-600 mt-2">
            Informe seu e-mail e enviaremos um link de redefinição (se estiver
            cadastrado).
          </p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4 mt-6">
          <div className="flex flex-col">
            <label className="text-sm font-medium text-blue-800 mb-1 flex items-center gap-2">
              <Mail className="w-5 h-5" /> Email
            </label>
            <input
              type="email"
              autoComplete="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="p-3 border border-blue-300 rounded-xl shadow-sm bg-white text-blue-900 outline-blue-500"
              required
              placeholder="ex: alex@mundosorriso.com"
            />
          </div>

          <button
            type="submit"
            disabled={carregando}
            className="w-full py-3 rounded-xl bg-blue-700 text-white font-semibold shadow-md hover:shadow-xl hover:bg-blue-800 transition-all duration-300 ease-in-out transform hover:-translate-y-0.5 disabled:opacity-60 disabled:hover:bg-blue-700"
          >
            {carregando ? "Enviando..." : "Enviar link de redefinição"}
          </button>

          <button
            type="button"
            onClick={() => navigate("/login")}
            className="w-full py-2 rounded-xl bg-gray-100 text-blue-900 font-semibold shadow-sm hover:bg-gray-200 transition flex items-center justify-center gap-2"
          >
            <ArrowLeft size={18} />
            Voltar ao login
          </button>
        </form>

        <p className="text-center text-sm text-gray-500 mt-4">
          © {new Date().getFullYear()} CaptaCRM. AWC Consultoria Sistemas Ltda.
        </p>
      </div>
    </div>
  );
}
